module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.items || !_vm.items.length) ? _c('span', [_vm._v("No items available")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.items), function(item, i) {
    return _c('v-chip', {
      key: i,
      staticClass: "mr-1 mb-1",
      attrs: {
        "color": _vm.color(item),
        "text-color": _vm.textColor(item)
      },
      on: {
        "click": function($event) {
          return _vm.toggleSelection(item)
        }
      }
    }, [_c('v-avatar', [(item._selected) ? _c('v-icon', {
      attrs: {
        "color": "blue darken-1"
      }
    }, [_vm._v("check_circle")]) : _c('v-icon', {
      attrs: {
        "color": "grey"
      }
    }, [_vm._v("account_circle")])], 1), _vm._v("\n        " + _vm._s(_vm.bestName(item)))], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95de312c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/ChipSelector.vue
// module id = 2630
// module chunks = 1